export class GmSoftRegisterEmailQueryParameters {
  APIKey?: string | null;
  EmailAddress?: string | null;
  FirstName?: string | null;
  GMIN?: string | null;
  SourceCode?: string | null;

  constructor(obj?: GmSoftRegisterEmailQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
